module.exports = __webpack_public_path__ + "img/bgEmploymentConfirmationApplication.1cdd6c15.png";